import * as React from 'react'

const SvgPageLastIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.25 10L5 16.25l-.875-.875L9.5 10 4.125 4.625 5 3.75 11.25 10zm2.5-7.5H15v15h-1.25v-15z"
      fill="#163250"
    />
  </svg>
)

export default SvgPageLastIcon
